/* eslint-disable @typescript-eslint/no-explicit-any */
import { EnvironmentWrapper } from 'hyarchis-global/environment';
import React, { lazy } from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import { EnvironmentFile } from './settings-files';

const root = document.getElementById('root');
const render = (): void => {
  const containerRoot = createRoot(root as Element);

  containerRoot.render(
    <EnvironmentWrapper
      settingsFiles={[EnvironmentFile]}
      component={lazy(() => import('./Main'))}
    />,
  );
};

if (module.hot) {
  const renderError = (error: any): any => {
    // eslint-disable-next-line @typescript-eslint/no-var-requires,global-require
    const RedBox = require('redbox-react');
    ReactDOM.render(<RedBox error={error} />, root);
  };

  const tryRender = (): void => {
    try {
      render();
    } catch (error) {
      renderError(error);
    }
  };

  (module as any).hot.accept('Main', () => {
    setTimeout(tryRender);
  });
}

render();
